import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from './PermissionsContext';

/**
 * ProtectedRoute
 * Props:
 * - required: string | string[] (AND)
 * - any: string | string[] (OR; optional)
 * - passThroughIfLoading: bool (optional) - if true and permissions are still loading, allow children
 */
export default function ProtectedRoute({ children, required = [], any = [], passThroughIfLoading = false }) {
  const { hasAllPermissions, hasAnyPermission, loading } = usePermissions();
  const req = Array.isArray(required) ? required : required ? [required] : [];
  const anyArr = Array.isArray(any) ? any : any ? [any] : [];

  if (loading && passThroughIfLoading) return children;

  const ok = (req.length === 0 || hasAllPermissions(req)) && (anyArr.length === 0 || hasAnyPermission(anyArr));
  if (!ok) return <Navigate to="/" replace />;
  return children;
}